
import Breadcrumb from '@/components/Breadcrumb'
import TitleBox from '@/components/CSS/TitleBox'
import TitleBox2 from '@/components/CSS/TitleBox2'
const OrderPayDialog = () => import('@/components/OrderPayDialog')
import { addQueryParams } from '@/utils'
import { mapGetters } from 'vuex'
// 卡券组件
import CouponItem from '@/components/CouponItem'
import CouponModal from '@/components/CouponModal'
import Cart from '@/components/GeneralGoodsDetail/Cart.vue'

export default {
	components: {
		CouponItem,
		Breadcrumb,
		TitleBox,
		TitleBox2,
		OrderPayDialog,
		Breadcrumb,
		CouponModal,
		Cart
	},
	data() {
		return {
			parChangeState: true, // 勾选协议
			centerDialogVisible2: false, // 购买须知
			centerPayDialogVisible: false, // 支付方式
			centerPayQRDialogVisible: false, // 关闭支付提示
			detailsData: null, // 商品信息
			calculateFee: null, //意向金
			compensationList: [], //基础包赔列表
			compensationListTwo: [], //增值包赔列表
			compensationFee: 0, //包赔金额
			compensationId: null, //包赔id
			compensationName: null, //包赔名称
			totalPrice: '', //总价
			parInfo: {}, //创建订单回调信息
			articleDetail: null, //购买须知
			valueAddCompensationIds: [], //增值包赔id合集
			compensationDetail: '', //包赔规则
			compensationAttentionItems: '', // 注意事项
			compensationVisibleData: '', // 包赔弹窗选中数据
			// 是否必选包赔
			compensation: {
				compensationAddNeed: null, //是否必选增值包赔
				compensationBasicNeed: null //是否必选基础包赔
			},
			couponList: [], //优惠卷列表
			usedcoupon: {}, // 选中要使用的优惠券
			couponLoading: false, // 获取优惠券的loading
			couponNum: 0, //记录默认最高金额优惠券
			dialogTitle: '购买协议',
			activeName: 'true',
			activeNameNum: 'true',
			tabs: [
				{
					name: 'true',
					label: '可用',
					count: 0
				},
				{
					name: 'false',
					label: '不可用',
					count: 0
				}
			],
			skuList: [], // sku数据
			quantity: Number(this.$route.query.quantity) || 1 // 数量
		}
	},
	computed: {
		...mapGetters({
			gameList: 'game/gameList',
			payInfo: 'game/payInfo',
			userAccount: 'user/userAccount'
		}),
		valueAddCompensationIdsPrice() {
			let nuber = 0
			this.valueAddCompensationIds.map(item => {
				nuber += item.compensationFee
			})
			return nuber
		},
		orderTypeTotalPrice() {
			// 优先使用当前SKU的价格
			return this.currentSkuPrice || this.detailsData.price || this.detailsData.transactionPrice
		},
		// 拆分总价的整数和小数（单价 * 数量）
		disassemblePrice() {
			const unitPrice = Number(this.$route.query.price) || this.currentSku?.skuPrice || this.detailsData.price
			const totalPrice = unitPrice * (this.quantity || 1)
			return totalPrice.toFixed(2)
		},
		selectCompensationList() {
			const result = []
			if (this.compensationId) result.push({ name: this.compensationName, price: this.compensationFee, key: this.compensationId })
			if (this.valueAddCompensationIds.length) {
				this.valueAddCompensationIds.forEach(item => {
					result.push({ name: item.name, price: item.compensationFee, key: item.id })
				})
			}
			return result
		},
		// 是否展示承保告知书
		showCompensationNotice() {
			console.log(1)
			return this.compensationId || this.valueAddCompensationIds.length > 0
		},
		// 根据skuId获取当前选中的SKU信息
		currentSku() {
			const skuId = this.$route.query.skuId
			return this.skuList.find(item => item.id === skuId) || {}
		},
		// 当前SKU的价格
		currentSkuPrice() {
			return Number(this.$route.query.price) || this.currentSku?.skuPrice || this.detailsData.price
		},
		// 当前SKU的标题
		currentSkuTitle() {
			return this.currentSku?.skuTitle || ''
		},
		// 当前SKU的商品数量
		currentSkuStock() {
			return Number(this.$route.query.stock) || this.currentSku?.skuStock || this.detailsData.stock
		},
		// 当前的快照ID
		currentSnapshotId() {
			return this.currentSku?.snapshotId || 0
		}
	},
	watch: {
		$route: {
			async handler(route) {
				if (process.client) {
					this.detailsData = await this.onLoadDetailsData()
					this.totalPrice = this.orderTypeTotalPrice
				}
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		// 包赔是否必填
		checkCompensation(compensationNeed, compensationList, compensationId, errorMessage) {
			if (compensationNeed) {
				if (!compensationList?.length) {
					this.$message.error('包赔服务错误，请联系客服')
					return false
				} else if (!compensationId) {
					this.$message.error(errorMessage)
					return false
				}
			}
			return true
		},
		async paymentSubmitData(data) {
			console.log(this.orderTypeTotalPrice, 'this.orderTypeTotalPrice')

			const res = await this.$api.createFictitiousOrder(data)
			if (res.success) {
				if (res.data.imCustomerService) {
					this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
					let customerData = {
						targetId: res.data.imCustomerService,
						conversationType: 1
					}
					this.$store.dispatch('ry/join', customerData)
					this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
					this.$store.commit('ry/SET_ORDER_FLOW', [])
					return
				}
				// 创建订单后埋点
				this.$trackEvent({ eventType: 'click', trackParams: { order_no: res.data.orderNo, goodsNo: this.detailsData.goodsNo } })
				// 创建订单成功后续处理
				this.parInfo = {
					...res.data,
					payTotalMoney: res.data.payMoney * this.quantity,
					transactionGoodsPrice: this.orderTypeTotalPrice
				}
				console.log(this.quantity, 'this.parInfo')

				this.centerPayDialogVisible = true
				this.$nextTick(() => {
					this.$refs['orderPayRef'].getPayqrCodeUrl(this.parInfo)
					// 当前页面状态变更为待支付
					addQueryParams({ ...this.$route.query, status: 'WAIT_PAY' })

					// 获取订单详情
					let _data = {
						orderNo: res.data.orderNo
					}
					this.$api.orderDetails(_data).then(getRes => {
						if (getRes.success) {
							// 重新对 detailsData 进行赋值
							// this.detailsData = getRes.data
							sessionStorage.setItem('orderDtl', JSON.stringify(this.detailsData))
						}
					})
				})
			} else {
				this.$message.error(res.info)
			}
		},
		// 检查是否被限制购买商品
		async onCheckLimit() {
			const par = {
				action: {
					userBizLimited: 'PROXY_AGENCY_CREATE_ORDER'
				}
			}
			const check = await this.$api.checkOrderLimit(par)
			if (!check.data) {
				this.$message.error(check.info)
				return false
			}
			return true
		},
		// 意向金提交
		async paymentSubmit() {
			this.$trackEvent({ eventType: 'click', trackParams: { 
				eventName: 'CC建联-商品卡片-确认支付',
				goodsNo: this.detailsData.goodsNo,
				packageId: this.currentSku.id || this.detailsData.masterSkuId
			}})
			let data = {
				action: {
					goodsNo: this.detailsData.goodsNo,
					goodsNum: this.quantity,
					skuId: this.currentSku.id || this.detailsData.masterSkuId,
					skuSnapshotId: this.currentSnapshotId || this.detailsData.snapshotId
				}
			}
			if(this.$route.query.businessSource === 'BUYER_SELLER'){
					const { changePrice, coalitionPriceId, businessSource } = this.$route.query
					data.action.businessSource = businessSource
					data.action.changePrice = changePrice === 'true'
					data.action.coalitionPriceId = coalitionPriceId
			}
			this.paymentSubmitData(data)
		},
		closePayModel() {
			this.centerPayDialogVisible = false
		},
		// 获取待支付详情
		getParOrderDtl() {
			let data = {
				orderNo: this.$route.query.orderNo || this.detailsData.orderNo
			}
			this.$api.orderDetails(data).then(res => {
				if (res.success) {
					this.detailsData = res.data
					this.parInfo = {
						...res.data,
						payName: '意向金'
					}
				}
			})
		},
		// 关闭支付方式弹窗
		closePayDialogVisible(done) {
			this.centerPayQRDialogVisible = true
			if (!this.centerPayQRDialogVisible) {
				done()
			}
		},
		// 退出支付方式
		closePayDialogOkVisible() {
			this.centerPayQRDialogVisible = false
			this.centerPayDialogVisible = false
			this.$refs['orderPayRef'].closeDialogVisible()

			this.$router.push({
				path: '/account/buyerDetails',
				query: { orderNo: this.parInfo.orderNo, parPage: 'true' }
			})
		},
		// 支付成功回调
		paySuccess(payStatus, msg = '支付失败') {
			if (payStatus === 'PAY_SUCCESS') {
				this.$message.success('支付成功！')
				// 是否是道具
				const isPropertyTrade = !!this.detailsData.isPropTrading
				this.$router.push({
					path: '/confirmOrder/paymentCallback',
					query: { orderNo: this.parInfo.orderNo, status: isPropertyTrade ? 3 : '' }
				})
			} else {
				this.centerPayDialogVisible = payStatus
				this.$refs['orderPayRef'].closeDialogVisible()
			}
		},
		calculateDiscount(coupon) {
			// 提前将数据解析并缓存，避免重复操作
			const compensationPrice = this.selectCompensationList.reduce((total, item) => total + Number.parseFloat(item.price || 0), 0)
			const couponValue = Number.parseFloat(coupon.couponsValue || 0)
			const scopeBusiness = Number.parseInt(coupon.scopeBusiness, 10)
			if (scopeBusiness === 1) {
				// 适用于包赔费用
				return Math.min(compensationPrice, couponValue)
			} else if (scopeBusiness === 2) {
				// 适用于订单总价
				const basicPrice = Number.parseFloat(this.orderTypeTotalPrice || 0)
				const totalPrice = basicPrice + compensationPrice
				return Math.min(totalPrice, couponValue)
			}
			// 默认返回 0（未知业务类型）
			return 0
		},
		// 查看购买须知
		getNotice(id, title) {
			this.dialogTitle = title
			let data = {
				action: {
					id
				}
			}
			this.$api.articleDetail(data).then(res => {
				if (res.success) {
					this.articleDetail = res.data
					this.centerDialogVisible2 = true
				} else {
					this.$message.error(res.info)
				}
			})
		},
		// 查看支付须知
		getPayNotice(id, title) {
			this.dialogTitle = title
			let data = {
				action: {
					id
				}
			}
			this.$api.getHagglingDetail(data).then(res => {
				if (res.success) {
					this.articleDetail = res.data
					this.centerDialogVisible2 = true
				} else {
					this.$message.error(res.info)
				}
			})
		},
		async onLoadDetailsData() {
			const res = await this.$api.getGeneralGoodsDetail({
				action: {
					goodsNo: this.$route.query.goodsNo
				}
			})
			if (!res.success) {
				return this.$message.error(res.info)
			}
			return res.data
		},
		async getCouponListData(val) {
			let data = {
				action: {
					gameId: val?.gameId,
					goodsCatalogueId: val?.goodsCatalogueId,
					goodsNo: val?.goodsNo
				}
			}
			const res = await this.$api.getGameConfig(data)
			if (!res.success) {
				this.$message.error(res.info)
				return
			}
			this.compensation = res.data[0]
		},
        // async byBusinessSource() {
        //     // gameId=137&goodsNo=SJDAMQG&skuId=747970714857902080&businessSource=BUYER_SELLER&changePrice=true&price=111&coalitionPriceId=fd3146a45d52d90e66b0809353f3e2b8&quantity=10
        //     const { goodsNo, coalitionPriceId, changePrice, skuId } = this.$route.query
        //     const par = {
        //         action: {
        //             businessSource: 'BUYER_SELLER',
        //             catalogueId,
        //             coalitionPriceId,
        //             goodsNo,
        //             changePrice: changePrice === 'true' ? false : true,
        //             skuId,
        //             skuSnapshotId,
        //             subCatalogueId,
        //         }
        //     }
        //     // 订单修改后商品价格
        //     const res = await this.$api.byBusinessSource(par)
        //     if (!res.success) {
        //         return this.$message.error(res.info)
        //     }
        // }
	},
	async mounted() {
		const params = {
			goodsNo: this.$route.query.goodsNo
		}

		const { data } = await this.$api.getGeneralGoodsSkuList(params)
		this.skuList = data || []

		if (this.$route.query.status == 'WAIT_PAY') {
			this.getParOrderDtl()
		}
        // if(this.$route.query.businessSource === 'BUYER_SELLER'){
        //     this.byBusinessSource();
        // }
	}
}
